import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import i18n, { translations } from 'i18n';
import { fitbitPremiumYellow } from '../../../themes';
import { roundEdgeDevices } from '../../../constants';

import { Screenshot } from 'types/app';

import DevicePreview from 'components/v2/Device';
import {CustomizeSign, CustomizeButtonTextContainer, CustomizeButtonContainer, CustomizeButton, StyledLink } from '../Common';
import ProgressBar from 'components/ProgressBar/index';
import EditIconWhite from '../../../icons/ic_edit_white.png';

interface DeviceProps {
  deviceName: string;
  setFocusedActiveClock: () => any;
  clock: {
    banners: Screenshot[];
    progress?: number;
    showProgress?: boolean;
    isPending?: boolean;
    isInstalling?: boolean;
    isSelected?: boolean;
    isActive?: boolean;
  };
}

interface ProgressContainerProps {
  isSquircle: boolean;
}

const horizontalCenter = css`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

const ProgressContainer = styled.div<ProgressContainerProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  ${({ isSquircle }) => isSquircle ? 'border-radius: 50px;' : ''}

  background-color: black;
`;

const ProgressTextWrapper = styled.div`
  top: calc(50% - 15px);
  ${horizontalCenter}

  font-size: 16px;
  color: #a0a8ac;
`;

const ProgressBarWrapper = styled.div`
  top: calc(50% + 15px);
  ${horizontalCenter}

  width: 78px;
`;

const ProgressOrLoading: FC<any> = (props) => (
  <ProgressContainer isSquircle={props.isSquircle}>
    <ProgressTextWrapper>
      {i18n('page.ClockGallery.MyClocks.switching')()}
    </ProgressTextWrapper>
    <ProgressBarWrapper>
      <ProgressBar {...props} />
    </ProgressBarWrapper>
  </ProgressContainer>
);

const Progress: FC<any> = ({ clock = {}, isSquircle }) => {
  const color = clock.isPremium ? fitbitPremiumYellow : undefined;
  if (clock.showProgress) {
    return <ProgressOrLoading percentage={clock.progress} color={color} isSquircle={isSquircle} />;
  }

  if (clock.isLoading) {
    return <ProgressOrLoading animation color={color} isSquircle={isSquircle} />;
  }

  return null;
};

const DeviceWrapper = styled.div`
  margin: 24px 0px 40px;
`;

const Device: FC<DeviceProps> = ({
  clock,
  deviceName,
  setFocusedActiveClock
}) => {
  const isSquircle = roundEdgeDevices.includes(deviceName);

  return (
    <DeviceWrapper
      onClick={setFocusedActiveClock}
      id='active-clock-image'
      aria-label='active-clock-image'
    >
      <DevicePreview
        deviceName={deviceName}
        image={clock.banners?.[0]}
      >
        <Progress clock={clock} isSquircle={isSquircle} />
      </DevicePreview>
    </DeviceWrapper>
  )
};

export default Device;
